import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

const styles = (theme) => ({
  root: {
    overflowX: 'hidden',
    overflowY: 'auto',
    width: '100%',
    height: 'calc(100vh - 85px)',
  },
  mainImg: {
    marginLeft: '14%',
    width: '900px',
    [theme.breakpoints.down('sm')]: {
      width: '90vw',
    },
  },
  logo: {
    position: 'static',
    [theme.breakpoints.down('sm')]: {
      width: '25vw',
      position: 'absolute',
      bottom: 30,
      left: '50%',
      transform: 'translate(-50%,0)',
    },
  },
});

class ComingSoon extends Component {
  constructor(props) {
    super(props);
    this.goToPage = this.goToPage.bind(this);
    this.state = {
      learnMoredialog: false,
      getStartedDialog: false,
      satellitesDialog: false,
      faqDialog: false,
      noticeDialog: false,
      welcomeMsgDialog: false,
      scoreDialog: false,
      emergencyDialog: false,
      supportDialog: false,
      programDialog: false,
    };
  }

  componentDidMount() {
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      this.setState({ matches: true });
    } else {
      this.setState({ matches: false });
    }
  }

  componentWillUnmount() {}

  goToPage(_move) {
    this.props.history.push(_move);
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div
          style={{
            textAlign: 'center',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div>
            <img src="images/coming_soon.png" alt="coming_soon" style={{}} className={classes.mainImg} />
          </div>
          <img src="images/innon_logo.png" alt="coming_soonmg" style={{}} className={classes.logo} />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(ComingSoon));
